package amazon.lastmile.inject

import app.nestbridge.feature.careteam.ui.CreateCareTeamUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateCareTeamUiFactory::class)
public interface AppNestbridgeFeatureCareteamUiCreateCareTeamUiFactory {
  @Provides
  @IntoSet
  public fun provideCreateCareTeamUiFactoryFactoryMultibinding(createCareTeamUiFactory: CreateCareTeamUiFactory): Ui.Factory = createCareTeamUiFactory
}
